const MASTER = `master`;
export const GET_CATEGORY = `${MASTER}/getCategory`;
export const GET_ACCESSLEVELS = `${MASTER}/GetAccessLevels`;
export const GET_ROLETYPE = `${MASTER}/GetRole`;
export const GET_USER_DETAILS_GUID = `${MASTER}/getUsersDetails/`;
export const GET_CONFIGURATION_VALUES = `${MASTER}/GetConfigurationValues`;
export const UPDATE_MASTER_CONFIG_DATA = `${MASTER}/UpdateMasterConfigData`;
export const CREATE_UPDATE_CONFIG_DATA = `${MASTER}/CreateUpdateConfigData`;
